import { Skeleton } from '@material-ui/lab';
/* eslint-disable no-shadow */
import { Fragment } from 'react';

import TableCell from './TableCell';
import TableRow from './TableRow';
import TableRowSeparator from './TableRowSeparator';

const TableLoader = ({ col = 6, row = 10 }) =>
  [...new Array(row)].map((_, index) => (
    <Fragment key={index}>
      <TableRow>
        {[...new Array(col)].map((_, index) => (
          <TableCell key={index}>
            <Skeleton />
          </TableCell>
        ))}
      </TableRow>
      <TableRowSeparator />
    </Fragment>
  ));

export default TableLoader;
